import React from 'react';
import PropTypes from 'prop-types';

import { ButtonContainer, Date } from './style';
import Arial from '../../typography/arial';

const Button = ({
  btnText, onClick, disabled, type, size, height, date
}) => (
  <ButtonContainer onClick={onClick} disabled={disabled} type={type} size={size} height={height}>
    <Arial type="button">{btnText}</Arial>
    {type === 'THIRD' && (
      <Date><Arial type="productCardDetail">{date}</Arial></Date>
    )}
  </ButtonContainer>
);

Button.TYPE = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  THIRD: 'THIRD'
};

Button.SIZE = {
  DEFAULT: 'DEFAULT',
  FULL: 'FULL'
};

Button.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  btnText: PropTypes.string.isRequired,
  size: PropTypes.oneOf(Object.keys(Button.SIZE)),
  type: PropTypes.string,
  height: PropTypes.number
};

Button.defaultProps = {
  size: Button.SIZE.DEFAULT,
  type: Button.TYPE.PRIMARY
};

export default Button;
